import React from 'react'
import DialogInputLabel from './DialogInputLabel'
import FormGroup from '@tencent/spaui-formgroup'
import Input from '@tencent/spaui-input'

const PkgNameInput = ({ value = '', error, onChange, label = '渠道包名称', placeholder = '请输入渠道包名称' }) => {
    return (
        <div className="track-body-item">
            <DialogInputLabel label={label} />
            <FormGroup error={error}>
                <Input value={value} placeholder={placeholder} onChange={(e, val) => onChange(val)} />
            </FormGroup>
        </div>
    )
}

export default PkgNameInput
